module.exports = __webpack_public_path__ + "img/calendar.e5795f85.webp";